import {useCallback, useEffect, useRef} from "react";
import axios from "axios";

export const isCancel = (error) => {
  return axios.isCancel(error);
};

export const useCancelableRequest = (cancelOnUnmount=true) => {
  const cancelSourceRef = useRef(null);

  const cancel = useCallback((message) => {
    if (cancelSourceRef.current) {
      cancelSourceRef.current.cancel(message);
      cancelSourceRef.current = null;
    }
  }, []);

  const getCancelToken = () => {
    // cancel previous request
    cancel("Canceled due to new request");

    // create new token
    cancelSourceRef.current = axios.CancelToken.source();

    return cancelSourceRef.current.token;
  };

  // cancel on unmount, unless the caller opts out
  useEffect(() => {
    if (cancelOnUnmount) return () => cancel("Component unmounted");
  }, [cancel, cancelOnUnmount]);

  return getCancelToken;
};